import React from "react";
import { matchPath } from "react-router-dom";
import { addNotification } from "reducers/Notifications";
import { D_TREE_URL } from "utils/constants";
import DTreeCreatedGrowl from "widgets/messages/DTreeCreatedGrowl";

const LIBRARY_ROUTE = "/library/:libraryId/";
const CREATIVE_ROUTE = "/library/:libraryId/creative/:creativeId/";

export function getDecisioningContext(pathname){
	const creativeMatch = matchPath(pathname, { path:CREATIVE_ROUTE });
	if(creativeMatch){
		return {
			creativeLibraryId:Number(creativeMatch.params.libraryId),
			creativeId:Number(creativeMatch.params.creativeId),
		};
	}

	const libraryMatch = matchPath(pathname, { path:LIBRARY_ROUTE });
	if(libraryMatch){
		return { creativeLibraryId:Number(libraryMatch.params.libraryId) };
	}

	return {};
}

export function buildVersionTreeUrl(treeId, creativeId){
	const creativeParam = creativeId ? `?creative=${creativeId}` : "";
	return `${D_TREE_URL}/v/edit/${treeId}${creativeParam}`;
}

// The decisioning agent returns the new tree's id in uiContext after creating one.
export function handleDecisioningResponse(event, { context, notifiedTreeIds, dispatch }){
	const treeId = event?.detail?.data?.uiContext?.treeId;
	if(!treeId || notifiedTreeIds.has(treeId)){ return; }

	notifiedTreeIds.add(treeId);
	const treeUrl = buildVersionTreeUrl(treeId, context.creativeId);
	dispatch(addNotification({
		type:"success",
		messageHeader:"Decision Tree Created",
		formatter:() => <DTreeCreatedGrowl treeUrl={treeUrl} />,
	}));
}
